import {Component, ComponentRef, Injector, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {TaskViewModel} from "../Model/TaskViewModel";
import {RouteViewModel} from "../../Routes/Model/RouteViewModel";
import {GeozoneViewModel} from "../../Geozone/Model/GeozoneViewModel";
import {DialogService} from "../../../../services/dialog.service";
import {ObjectsManagementDialogComponent} from "../../objects-management-dialog/objects-management-dialog.component";
import {ConverterService} from "../../../../services/converter.service";
import { MapObject, MapPoint } from "../../../shared/components/simple-map/c.component";
import { JSProxyService } from "../../../../services/jsproxy.service";
import {ObjectCreateViewModel} from "../../Objects/Models/ObjectViewModel";

@Component({
    selector: 'app-tasks-dialog-base',
    templateUrl: './tasks-dialog-base.component.html',
    styleUrls: ['./tasks-dialog-base.component.css'],
    standalone: false
})
export class TasksDialogBaseComponent extends DialogBaseComponent<TaskViewModel> implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;

  public trackers: ObjectCreateViewModel[] = [];
  public geozones: GeozoneViewModel[] = [];
  public routes: RouteViewModel[] = [];
  private dialogService: DialogService;
  private converterService: ConverterService;
  private jsProxyService: JSProxyService;

  public coordinate: string = "";

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogService = injector.get(DialogService);
    this.converterService = injector.get(ConverterService);
    this.jsProxyService = injector.get(JSProxyService);
  }

  ngOnInit() {
    super.ngOnInit();


    if (this.model.Latitude != undefined && this.model.Longitude != undefined)
      this.coordinate = this.model.Latitude.toFixed(5) + " " + this.model.Longitude.toFixed(5);
  }

  public selectPoint()
  {
    const mapDialog = this.jsProxyService.getComponent("CommonDialogs").openMapModal();

    mapDialog.onSubmit.subscribe(() => {
      if (mapDialog.points && mapDialog.points.length)
      {
          this.model.Latitude = mapDialog.points[0].lat;
          this.model.Longitude = mapDialog.points[0].lng;

          this.coordinate = this.model.Latitude.toFixed(5) + " " + this.model.Longitude.toFixed(5);

          mapDialog.close();
      }
    });

    const mapObject = new MapObject();
    if (this.model.Latitude != undefined && this.model.Longitude != undefined)
      mapObject.points.push(new MapPoint(this.model.Latitude, this.model.Longitude));
    mapObject.modify = true;
    mapDialog.ShowObjects([mapObject]);
  }

  public selectGeoZone() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer,ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.geozones;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(zone => {
        if (zone && zone.IsChecked) {
          this.model.ZoneId = zone.Id;
          this.model.Zone = zone;
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }
  public selectRoute() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer,ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.routes;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(route => {
        if (route && route.IsChecked) {
          this.model.RouteId = route.Id;
          this.model.Route = route;
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }
  public selectTracker() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer,ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.trackers;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(tracker => {
        if (tracker && tracker.IsChecked) {
          this.model.TrackerId = tracker.Id;
          this.model.Tracker = tracker;
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }

  public convertRadius(value: number) {
    this.model.Radius = this.converterService.ParseMeters(value);
  }
}
